// extracted by mini-css-extract-plugin
export default {"header":"ProgramMedicinesTable_header__D15vz","add":"ProgramMedicinesTable_add__luyKK","cogwheel":"ProgramMedicinesTable_cogwheel__NDy-3"};